import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_TIME_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterCBondsTradingsTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "IDMercadoNegociacao": null,
            "IDEmissao": null,
            "IDTipoEmissao": null,
            "IDEmitente": null,
            "IDPaisEmitente": null,
            "IDRegiaoPaisEmitente": null,
            "IDTipoEmitente": null,
            "ISIN": null,
            "ISIN144a": null,
            "ISIN3": null,
            "IDPainel": null,
            "MostrarRu": null,
            "CotacaoCompra": null,
            "CotacaoVenda": null,
            "PrecoUltimo": null,
            "PrecoAbertura": null,
            "PrecoMaximo": null,
            "PrecoMinimo": null,
            "PrecoMedio": null,
            "NumeroAcordo": null,
            "PrecoIntermediario": null,
            "VolumeNegociado": null,
            "LucroLiquidacao": null,
            "DataOferta": dayjs().format(DATE_FORMAT),
            "LucroOferta": null,
            "EfeitoLucroLiquidacao": null,
            "EfeitoLucroOferta": null,
            "EfeitoLucroCupom": null,
            "LucroNominalLiquidacao": null,
            "LucroNominalOferta": null,
            "LucroNominalCupom": null,
            "LucroCupom": null,
            "Duration": null,
            "DurationModificada": null,
            "DurationModificadaPara": null,
            "JurosAccruados": null,
            "YieldVencimentoCompra": null,
            "YieldVencimentoVenda": null,
            "YieldOpcaoCompra": null,
            "YieldOpcaoVenda": null,
            "YieldChamadaCompra": null,
            "YieldChamadaVenda": null,
            "YieldVencimentoUltimo": null,
            "YieldOpcaoUltimo": null,
            "YieldChamadaUltimo": null,
            "YieldVencimentoFechamento": null,
            "YieldOpcaoFechamento": null,
            "YieldChamadaFechamento": null,
            "YieldVencimentoAbertura": null,
            "YieldVencimentoMaximo": null,
            "YieldVencimentoMinimo": null,
            "PrecoLiquidacao": null,
            "DurationPara": null,
            "PrecoMercado": null,
            "PrecoMercado2": null,
            "Quantidade": null,
            "VolumeFinanceiro": null,
            "AnosParaVencimento": null,
            "AnosParaOferta": null,
            "PVBP": null,
            "PVBP_Offer": null,
            "Convexidade": null,
            "Convexidade_Offer": null,
            "CotacaoAdmitida": null,
            "PrecoFechamentoLegal": null,
            "DurationCupom": null,
            "GSpread": null,
            "TSpread": null,
            "TSpreadReferencia": null,
            "TaxaAccrual": null,
            "PrecoIndicativo": null,
            "TipoPrecoIndicativo": null,
            "TaxaMTM": null,
            "TipoYieldIndicativo": null,
            "SpreadCompraVenda": null,
            "JurosAcumuladosEurobondNominal": null,
            "PUMTM_Sujo": null,
            "HoraAtualizacao": dayjs().format(DATE_TIME_FORMAT_SHOW),
            "created_at": dayjs().format(DATE_TIME_FORMAT_SHOW),
            "updated_at": dayjs().format(DATE_TIME_FORMAT_SHOW),
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            DataReferencia,
            IDMercadoNegociacao,
            IDEmissao,
            IDTipoEmissao,
            IDEmitente,
            IDPaisEmitente,
            IDRegiaoPaisEmitente,
            IDTipoEmitente,
            ISIN,
            ISIN144a,
            ISIN3,
            IDPainel,
            MostrarRu,
            CotacaoCompra,
            CotacaoVenda,
            PrecoUltimo,
            PrecoAbertura,
            PrecoMaximo,
            PrecoMinimo,
            PrecoMedio,
            NumeroAcordo,
            PrecoIntermediario,
            VolumeNegociado,
            LucroLiquidacao,
            DataOferta,
            LucroOferta,
            EfeitoLucroLiquidacao,
            EfeitoLucroOferta,
            EfeitoLucroCupom,
            LucroNominalLiquidacao,
            LucroNominalOferta,
            LucroNominalCupom,
            LucroCupom,
            Duration,
            DurationModificada,
            DurationModificadaPara,
            JurosAccruados,
            YieldVencimentoCompra,
            YieldVencimentoVenda,
            YieldOpcaoCompra,
            YieldOpcaoVenda,
            YieldChamadaCompra,
            YieldChamadaVenda,
            YieldVencimentoUltimo,
            YieldOpcaoUltimo,
            YieldChamadaUltimo,
            YieldVencimentoFechamento,
            YieldOpcaoFechamento,
            YieldChamadaFechamento,
            YieldVencimentoAbertura,
            YieldVencimentoMaximo,
            YieldVencimentoMinimo,
            PrecoLiquidacao,
            DurationPara,
            PrecoMercado,
            PrecoMercado2,
            Quantidade,
            VolumeFinanceiro,
            AnosParaVencimento,
            AnosParaOferta,
            PVBP,
            PVBP_Offer,
            Convexidade,
            Convexidade_Offer,
            CotacaoAdmitida,
            PrecoFechamentoLegal,
            DurationCupom,
            GSpread,
            TSpread,
            TSpreadReferencia,
            TaxaAccrual,
            PrecoIndicativo,
            TipoPrecoIndicativo,
            TaxaMTM,
            TipoYieldIndicativo,
            SpreadCompraVenda,
            JurosAcumuladosEurobondNominal,
            PUMTM_Sujo,
            HoraAtualizacao,
            created_at,
            updated_at
        } = newRow

        const body = {
            "DataReferencia": DataReferencia,
            "IDMercadoNegociacao": IDMercadoNegociacao,
            "IDEmissao": IDEmissao,
            "IDTipoEmissao": IDTipoEmissao,
            "IDEmitente": IDEmitente,
            "IDPaisEmitente": IDPaisEmitente,
            "IDRegiaoPaisEmitente": IDRegiaoPaisEmitente,
            "IDTipoEmitente": IDTipoEmitente,
            "ISIN": ISIN,
            "ISIN144a": ISIN144a,
            "ISIN3": ISIN3,
            "IDPainel": IDPainel,
            "MostrarRu": MostrarRu,
            "CotacaoCompra": CotacaoCompra,
            "CotacaoVenda": CotacaoVenda,
            "PrecoUltimo": PrecoUltimo,
            "PrecoAbertura": PrecoAbertura,
            "PrecoMaximo": PrecoMaximo,
            "PrecoMinimo": PrecoMinimo,
            "PrecoMedio": PrecoMedio,
            "NumeroAcordo": NumeroAcordo,
            "PrecoIntermediario": PrecoIntermediario,
            "VolumeNegociado": VolumeNegociado,
            "LucroLiquidacao": LucroLiquidacao,
            "DataOferta": DataOferta,
            "LucroOferta": LucroOferta,
            "EfeitoLucroLiquidacao": EfeitoLucroLiquidacao,
            "EfeitoLucroOferta": EfeitoLucroOferta,
            "EfeitoLucroCupom": EfeitoLucroCupom,
            "LucroNominalLiquidacao": LucroNominalLiquidacao,
            "LucroNominalOferta": LucroNominalOferta,
            "LucroNominalCupom": LucroNominalCupom,
            "LucroCupom": LucroCupom,
            "Duration": Duration,
            "DurationModificada": DurationModificada,
            "DurationModificadaPara": DurationModificadaPara,
            "JurosAccruados": JurosAccruados,
            "YieldVencimentoCompra": YieldVencimentoCompra,
            "YieldVencimentoVenda": YieldVencimentoVenda,
            "YieldOpcaoCompra": YieldOpcaoCompra,
            "YieldOpcaoVenda": YieldOpcaoVenda,
            "YieldChamadaCompra": YieldChamadaCompra,
            "YieldChamadaVenda": YieldChamadaVenda,
            "YieldVencimentoUltimo": YieldVencimentoUltimo,
            "YieldOpcaoUltimo": YieldOpcaoUltimo,
            "YieldChamadaUltimo": YieldChamadaUltimo,
            "YieldVencimentoFechamento": YieldVencimentoFechamento,
            "YieldOpcaoFechamento": YieldOpcaoFechamento,
            "YieldChamadaFechamento": YieldChamadaFechamento,
            "YieldVencimentoAbertura": YieldVencimentoAbertura,
            "YieldVencimentoMaximo": YieldVencimentoMaximo,
            "YieldVencimentoMinimo": YieldVencimentoMinimo,
            "PrecoLiquidacao": PrecoLiquidacao,
            "DurationPara": DurationPara,
            "PrecoMercado": PrecoMercado,
            "PrecoMercado2": PrecoMercado2,
            "Quantidade": Quantidade,
            "VolumeFinanceiro": VolumeFinanceiro,
            "AnosParaVencimento": AnosParaVencimento,
            "AnosParaOferta": AnosParaOferta,
            "PVBP": PVBP,
            "PVBP_Offer": PVBP_Offer,
            "Convexidade": Convexidade,
            "Convexidade_Offer": Convexidade_Offer,
            "CotacaoAdmitida": CotacaoAdmitida,
            "PrecoFechamentoLegal": PrecoFechamentoLegal,
            "DurationCupom": DurationCupom,
            "GSpread": GSpread,
            "TSpread": TSpread,
            "TSpreadReferencia": TSpreadReferencia,
            "TaxaAccrual": TaxaAccrual,
            "PrecoIndicativo": PrecoIndicativo,
            "TipoPrecoIndicativo": TipoPrecoIndicativo,
            "TaxaMTM": TaxaMTM,
            "TipoYieldIndicativo": TipoYieldIndicativo,
            "SpreadCompraVenda": SpreadCompraVenda,
            "JurosAcumuladosEurobondNominal": JurosAcumuladosEurobondNominal,
            "PUMTM_Sujo": PUMTM_Sujo,
            "HoraAtualizacao": HoraAtualizacao,
            "created_at": created_at,
            "updated_at": updated_at
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'IDMercadoNegociacao',
            headerName: 'IDMercadoNegociacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number',
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipoEmissao',
            headerName: 'IDTipoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDEmitente',
            headerName: 'IDEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDPaisEmitente',
            headerName: 'IDPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDRegiaoPaisEmitente',
            headerName: 'IDRegiaoPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipoEmitente',
            headerName: 'IDTipoEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ISIN144a',
            headerName: 'ISIN144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ISIN3',
            headerName: 'ISIN3',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDPainel',
            headerName: 'IDPainel',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarRu',
            headerName: 'MostrarRu',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CotacaoCompra',
            headerName: 'CotacaoCompra',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CotacaoVenda',
            headerName: 'CotacaoVenda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoUltimo',
            headerName: 'PrecoUltimo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoAbertura',
            headerName: 'PrecoAbertura',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoMaximo',
            headerName: 'PrecoMaximo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoMinimo',
            headerName: 'PrecoMinimo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoMedio',
            headerName: 'PrecoMedio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NumeroAcordo',
            headerName: 'NumeroAcordo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoIntermediario',
            headerName: 'PrecoIntermediario',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'VolumeNegociado',
            headerName: 'VolumeNegociado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'LucroLiquidacao',
            headerName: 'LucroLiquidacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataOferta',
            headerName: 'DataOferta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'LucroOferta',
            headerName: 'LucroOferta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'EfeitoLucroLiquidacao',
            headerName: 'EfeitoLucroLiquidacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'EfeitoLucroOferta',
            headerName: 'EfeitoLucroOferta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'EfeitoLucroCupom',
            headerName: 'EfeitoLucroCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'LucroNominalLiquidacao',
            headerName: 'LucroNominalLiquidacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'LucroNominalOferta',
            headerName: 'LucroNominalOferta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'LucroNominalCupom',
            headerName: 'LucroNominalCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'LucroCupom',
            headerName: 'LucroCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'Duration',
            headerName: 'Duration',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DurationModificada',
            headerName: 'DurationModificada',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DurationModificadaPara',
            headerName: 'DurationModificadaPara',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'JurosAccruados',
            headerName: 'JurosAccruados',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoCompra',
            headerName: 'YieldVencimentoCompra',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoVenda',
            headerName: 'YieldVencimentoVenda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldOpcaoCompra',
            headerName: 'YieldOpcaoCompra',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldOpcaoVenda',
            headerName: 'YieldOpcaoVenda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldChamadaCompra',
            headerName: 'YieldChamadaCompra',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldChamadaVenda',
            headerName: 'YieldChamadaVenda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoUltimo',
            headerName: 'YieldVencimentoUltimo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldOpcaoUltimo',
            headerName: 'YieldOpcaoUltimo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldChamadaUltimo',
            headerName: 'YieldChamadaUltimo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoFechamento',
            headerName: 'YieldVencimentoFechamento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldOpcaoFechamento',
            headerName: 'YieldOpcaoFechamento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldChamadaFechamento',
            headerName: 'YieldChamadaFechamento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoAbertura',
            headerName: 'YieldVencimentoAbertura',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoMaximo',
            headerName: 'YieldVencimentoMaximo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'YieldVencimentoMinimo',
            headerName: 'YieldVencimentoMinimo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoLiquidacao',
            headerName: 'PrecoLiquidacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DurationPara',
            headerName: 'DurationPara',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoMercado',
            headerName: 'PrecoMercado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'PrecoMercado2',
            headerName: 'PrecoMercado2',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'Quantidade',
            headerName: 'Quantidade',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'VolumeFinanceiro',
            headerName: 'VolumeFinanceiro',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'AnosParaVencimento',
            headerName: 'AnosParaVencimento',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'AnosParaOferta',
            headerName: 'AnosParaOferta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PVBP',
            headerName: 'PVBP',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PVBP_Offer',
            headerName: 'PVBP_Offer',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'Convexidade',
            headerName: 'Convexidade',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'Convexidade_Offer',
            headerName: 'Convexidade_Offer',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CotacaoAdmitida',
            headerName: 'CotacaoAdmitida',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoFechamentoLegal',
            headerName: 'PrecoFechamentoLegal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DurationCupom',
            headerName: 'DurationCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'GSpread',
            headerName: 'GSpread',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TSpread',
            headerName: 'TSpread',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TSpreadReferencia',
            headerName: 'TSpreadReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TaxaAccrual',
            headerName: 'TaxaAccrual',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoIndicativo',
            headerName: 'PrecoIndicativo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoPrecoIndicativo',
            headerName: 'TipoPrecoIndicativo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'TaxaMTM',
            headerName: 'TaxaMTM',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoYieldIndicativo',
            headerName: 'TipoYieldIndicativo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
        },
        {
            field: 'SpreadCompraVenda',
            headerName: 'SpreadCompraVenda',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'JurosAcumuladosEurobondNominal',
            headerName: 'JurosAcumuladosEurobondNominal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PUMTM_Sujo',
            headerName: 'PUMTM_Sujo',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'HoraAtualizacao',
            headerName: 'HoraAtualizacao',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW) : '',
        },
        {
            field: 'created_at',
            headerName: 'created_at',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW) : '',
        },
        {
            field: 'updated_at',
            headerName: 'updated_at',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW) : '',
        },

        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterCBondsTradingsTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterCBondsTradingsTable